// extracted by mini-css-extract-plugin
export default {"ellipsis":"---------packages-corgi-x-src-components-Ellipsis-Ellipsis-module__ellipsis"};